import axios, { AxiosRequestConfig } from "axios";
const { history } = require("../../configs/lib");
const { API_URL, Storage } = require("../../configs/lib");
const { platform } = require("../../configs/constant");
axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
  // const token = await Storage.getItem("adminToken");
  var token = ""
  if (platform === 'Mobile') {
    token = await Storage.getItem('jwtToken');
  }
  else {
    token = await Storage.getItem("adminToken");
  }
  config.baseURL = API_URL;
  config.headers = {
    common: {
      "Access-Control-Allow-Origin": API_URL,
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  };
  config.headers.authorization = token ? `Bearer ${token}` : "";
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === "Network Error") {
      error.response = {
        status: 500,
        data: {
          message: "Network Error | Network Unavailable",
        },
      };
    }
    if (error.response.status === 401) {
      //temporory code
      Storage.removeItem("adminToken");
      history.push(`${process.env.PUBLIC_URL}/signin`);
    }
    if (error.response.status === 500) {
      if (!error.response.data || !error.response.data.message) {
        error.response = {
          status: 500,
          data: {
            message: "Something went wrong",
          },
        };
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
